import React from "react";
import { Button, Col, Flex, Layout, Modal, notification, Row, Skeleton, Space } from "antd";
import { mdiAccountCash, mdiAccountGroup, mdiAirplane, mdiBagChecked, mdiBedKing, mdiClose, mdiEmailOutline, mdiFileDownload, mdiFlagTriangle, mdiMapMarker, mdiMapMarkerOutline, mdiMenuDown, mdiMenuUp, mdiPhoneInTalkOutline, mdiReceiptText, mdiShieldAccount, mdiShieldAirplane, mdiSilverwareForkKnife, mdiWhatsapp, mdiWifi } from "@mdi/js";
import Icon from "@mdi/react";
import Headline from "./Headline";
import { Content } from "antd/es/layout/layout";
import Sider from "antd/es/layout/Sider";
import { useParams, useSearchParams } from "react-router-dom";
import ContactAgentsForm from "../../components/shared/ContactAgentsForm";
import Markdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";
import { Itinerary, Tour } from '../../interfaces/itinerary.interface';
import SeriesApi from '../../api-services/series-api.service';
import AgentsApi from '../../api-services/agents-api.service';
import { Agent } from "../../interfaces/agent.interface";
import TourDateSelector from "../../components/shared/TourDateSelector";
import PriceDetails from "../../components/shared/PriceDetails";
import HomeLink from "../../widgets/HomeLink";
import ItineraryDownloadLinks from "../../components/shared/ItineraryDownloadLinks";

const breadcrumbs = [
  { title: <HomeLink/>},
]

const nonNull = (arr, propName:string) => arr.map(a => a[propName]!).filter(a => a);
const uniqBy = (arr, propName:string) => {
  const values:string[] = nonNull(arr, propName)
  return [...new Set(values)].sort();
}

const inclusions = (inclusionsData: Itinerary['includings'], insuranceZone?: string, policyUrl?: string, benefitUrl?: string, guaranteeTourLeaderSeat?: number | null | undefined) => {
  if (!inclusionsData) {
    return [];
  }

  return [
    {icon: <Icon path={mdiShieldAccount} size={1} />, label: "Free Travel Insurance", visible: inclusionsData.acf, content: () => (
      <span>
        {insuranceZone && (insuranceZone + (policyUrl || benefitUrl ? " - " : ""))}
        {policyUrl && <a href={policyUrl} target="_blank" rel="noopener noreferrer">Policy</a>}
        {policyUrl && benefitUrl && " | "}
        {benefitUrl && <a href={benefitUrl} target="_blank" rel="noopener noreferrer">Benefit</a>}
      </span>
    )},
    {icon: <Icon path={mdiReceiptText} size={1} />  , label: "Airport Taxes", visible: inclusionsData.airport_taxes},
    {icon: <Icon path={mdiFlagTriangle} size={1} />, label: guaranteeTourLeaderSeat === 0 ? "Tour Leader" : `Tour Leader (min. group size ${guaranteeTourLeaderSeat} pax)`, visible: guaranteeTourLeaderSeat !== null && guaranteeTourLeaderSeat !== undefined},
    {icon: <Icon path={mdiBagChecked} size={1} />, label: "Check-in Baggage", visible: inclusionsData.luggage},
    {icon: <Icon path={mdiSilverwareForkKnife} size={1} />, label: "Meal Onboard", visible: inclusionsData.meal_onboard},
    {icon: <Icon path={mdiBedKing} size={1} />, label: "Hotel", visible: inclusionsData.hotel},
    {icon: <Icon path={mdiAccountCash} size={1} />, label: "Gratuities", visible: inclusionsData.gratuities},
    {icon: <Icon path={mdiAccountGroup} size={1} />, label: "Group Departure", visible: inclusionsData.group_departure},
    {icon: <Icon path={mdiWifi} size={1} />, label: "Wi-Fi", visible: inclusionsData.wifi}
  ];
}

const layoutStyle = {
  overflow: 'hidden',
};

const siderStyle = {
  backgroundColor: 'transparent'
}


function withParams(Component) {
  return props => <Component {...props} params={useParams()} searchParams={useSearchParams()} />;
}

interface IShowPage {
  loading: boolean;
  itinerary: any,
  selectedTour: any,
  setIsModalOpen: boolean;
  loadingAgents: boolean;
  allAgents: any[],
  agents: any[],
  states: any[],
  cities: any[],
  showAgentsResults: boolean,
  agentData: any,
  isCollapsed: boolean,
  showContactAgent: boolean,
  selectedDate: string,
  tourInclusives: any[],
  type: string
}

class ShowPage extends React.Component <{params, searchParams}> {
  seriesApi = new SeriesApi;
  agentsApi = new AgentsApi;

  state:IShowPage = {
    loading: false,
    itinerary: {tours: []},
    selectedTour:{id: null,guaranteed_indicator:"", flights:[], caption:"", code:"", prices: []},
    setIsModalOpen: false,
    loadingAgents: true,
    allAgents: [],
    agents: [],
    states: [],
    cities: [],
    showAgentsResults: false,
    agentData: { name: "", image: "", address: "", phone: "", whatsapp: "", email: "", city: "", state: "" },
    isCollapsed: true,
    showContactAgent: false,
    selectedDate: "",
    tourInclusives: [],
    type: "series"
  }


  componentDidMount() {
    const [searchParams] = this.props.searchParams;
    const departDate = searchParams.get('depart_date');
    const type = searchParams.get('type');
    this.getItinerary(departDate, type);

    this.getAgents();
  }

  getItinerary(date, type?, selectedTourCode?){
    this.setState({loading: true, type});

    this.seriesApi.getItinerary(this.props.params.id, type, date, "b2b")
      .then((itineraryData:Itinerary) => {      
        if(itineraryData.tours && itineraryData.tours?.length > 0){
          let selectedTour:any = itineraryData.tours[0];
          if (date) {
            const byDate = itineraryData.tours.find(({departure_date, code}) => departure_date === date && (!selectedTourCode || code === selectedTourCode));
            if (byDate) selectedTour = byDate;
          }
          const tourInclusives = inclusions(itineraryData.includings, selectedTour?.insurance_zone, itineraryData.insurancePolicyUrl, itineraryData.insuranceBenefitUrl, selectedTour.guarantee_tour_leader_seat);
          this.setState({itinerary: itineraryData, tourInclusives, selectedTour, selectedDate: date, loading: false});
        } else {
          const tourInclusives = inclusions(itineraryData.includings, undefined, undefined, undefined, null);
          this.setState({itinerary: itineraryData, tourInclusives, loading: false});
        }
      })
      .finally(()=>this.setState({loading: false}))
      .catch(error => {
        notification.error({ message: 'An error occured while loading itinerary.'});
      });
  }


  getAgents(){
    this.agentsApi.getAgents({departments: "Signature"})
      .then((agentsData:Agent[]) => {
        const states = uniqBy(agentsData, "state"), cities = uniqBy(agentsData, "city");
        this.setState({agents: agentsData, allAgents: agentsData, states, cities});
        this.resetAgents(agentsData);
      })
      .finally(()=>this.setState({loading: false}))
      .catch(error => {
        notification.error({ message: 'An error occured while loading agents.'});
      });
  }

  selectTour(tourDate){
    const selectedTour:any = this.state.itinerary.tours.find((tour:any) => tour.departure_date == tourDate);
    if(selectedTour){
      this.setState({selectedTour, selectedDate: tourDate});
    }
  }

  showModal(agentData){
    this.setState({setIsModalOpen: true, agentData: agentData});
  };

  closeModal(){
    this.setState({setIsModalOpen: false});
  };


  filterCities = (searchStr) => {
    const allAgents:Agent[] = this.state.allAgents;

    if(searchStr == undefined){
      this.resetAgents();
      return;
    }
    const agents:Agent[] = allAgents.filter(a => a.state == searchStr);
    const results = uniqBy(agents, 'city');
    this.setState({cities: results});
  }


  filterStates= (searchStr) => {
    const allAgents:Agent[] = this.state.allAgents;

    if(searchStr == undefined){
      this.resetAgents();
      return;
    }
    
    const agents:Agent[] = allAgents.filter(a => a.city == searchStr);
    const results = uniqBy(agents, 'state');
    this.setState({states: results});
  }

  resetAgents(agents?){
    const allAgents:Agent[] = agents || this.state.allAgents;
    const states = uniqBy(allAgents, "state"), cities = uniqBy(allAgents, "city");
    this.setState({states, cities});
  }

  findAgents = (formValues) => {
    const allAgents:Agent[] = this.state.allAgents;
    const agents = allAgents.filter(a => 
      (formValues.state == undefined || a.state === formValues.state) && 
      (formValues.city == undefined || a.city === formValues.city));
    this.setState({agents, showAgentsResults: true})
  }


  toggleDescription = () => {
    const collapsed = this.state.isCollapsed;
    this.setState({isCollapsed: !collapsed});
  }

  toggleContactAgent = () => {
    const collapsed = this.state.showContactAgent;
    this.setState({showContactAgent: !collapsed});
  }


  render(){
    const {loading, itinerary, selectedTour, agents, states, cities, agentData, isCollapsed, showContactAgent, selectedDate, tourInclusives, type} = this.state;
    const dates = itinerary.tours.length == 0 ? [] : itinerary.tours.map((tour:any) => {
        const type = tour.guaranteed_indicator == "G" ?  "guaranteed" :  tour.guaranteed_indicator == "X to G" ?  "almost-guaranteed" : "";
        return {code: tour.code, date: tour.departure_date, price: tour.price, type}
      });

    return (
      <div id="show-page">

      <Layout style={layoutStyle}>
        
        <>
          <Headline showSearch={false} bannerImage={itinerary.coverImage} breadcrumbs={breadcrumbs}>
            <div id="show-page_header"> 
              <Flex justify="space-between" vertical gap={45}>
                <h1>{selectedTour?.caption}</h1> 
                <div className="tour_details"> 
                  <span className="tour_details_country"> <Icon path={mdiMapMarkerOutline} size="16px" />  {itinerary?.country} </span> 
                  <span className="tour_details_code"> <Icon path={mdiFileDownload} size="16px" />  {selectedTour?.code} </span> 
                </div>
              </Flex>
            </div>
          </Headline>

          <div id="show-page_subheader">
            <TourDateSelector 
              dates={dates} 
              selectedDate={selectedDate} 
              selectedTourCode={selectedTour.code} 
              selectTour={({date, code})=>this.getItinerary(date, type, code)}
              category={itinerary?.category || ""}
              isNew={!!itinerary?.isNew}/>
          </div>
        </>
        
        <Layout id="show-page_body">
          <Content>
            {
              loading ? (
                <Space direction="vertical" style={{width: '100%'}}>
                  <Skeleton/>
                  <Skeleton/>
                  <Skeleton/>
                </Space>
              ) : (
                <div className="details">
                  <Flex gap={10} vertical>
                    <div className="details-container">
                      <div className="details-container_header"> Tour Inclusive </div>
                      <div className="details-container_content"> 
                        <div id="things-to-know">
                          {
                            tourInclusives.filter(item => item.visible)
                              .map((item, index) => (
                                <div key={index} className="item">
                                  <div className="icon"> {item.icon} </div>
                                  <label>{item.label}</label>
                                  {item.content && <div className="item-description">{item.content()}</div>}
                                </div>
                              ))
                          }

                          <ItineraryDownloadLinks itinerary={itinerary} />

                          {
                            selectedTour?.guaranteed_indicator == "G" && (
                              <div className="item guaranteed">
                                <div className="icon"> <Icon path={mdiShieldAirplane} size={1} /></div>
                                <label>Guaranteed Departure</label>
                              </div>
                            )
                          }
                        </div>
                      </div>
                    </div>

                    <div className="details-container">
                      <div className="details-container_header"> Description </div>
                      <div className="details-container_content"> 
                        <div id="description" className={`${isCollapsed && 'collapsed'}`}>
                          <Markdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>{itinerary?.description}</Markdown>
                        </div>
                        <Button className="toggle-description" color="default" variant="filled" block onClick={this.toggleDescription}>{ isCollapsed ? 'Expand' : 'Collapse'} 
                          <Icon path={isCollapsed ? mdiMenuDown : mdiMenuUp} size="19px" /> 
                        </Button>
                      </div>
                    </div>

                    {
                      selectedTour?.flights?.length > 0  && (
                        <div className="details-container">
                          <div className="details-container_header"> Schedule Flight(s) </div>
                          <div className="details-container_content"> 
                            <Flex gap={20} vertical>
                              {
                                selectedTour?.flights.map((flight:any) => (
                                  <div className="schedule" key={flight.id}>
                                    <div className="flight-date"> 
                                      <Icon path={mdiAirplane} size="12px" />
                                      <span>{flight.departure_date}</span>
                                    </div>
                                    <div className="flight-details"> 
                                      <label> {flight.from_airport} &gt; {flight.to_airport} </label>
                                      <div className="flight-details_airline">
                                        <img src={flight.airline_logo} />
                                        <span>{flight.airline}</span>
                                      </div>
                                    </div>
                                    <div className="flight-time"> 
                                      <Flex gap={13}>
                                        <div className="from">
                                          <label>{flight.departure_time}</label>
                                          <span>{flight.from_airport}</span>
                                        </div>
                                        <div className="flight-time_icon">
                                          <img src="/iceholidays-assets/images/plane.png" />
                                        </div>
                                        <div className="to">
                                          <label>{flight.arrival_time}</label>
                                          <span>{flight.to_airport}</span>
                                        </div>
                                      </Flex>
                                    </div>
                                  </div>
                                ))
                              }
                            </Flex>
                          </div>
                        </div>
                      )
                    }

                    {selectedTour?.prices.length > 0 && <PriceDetails priceCurrency={itinerary.priceCurrency} prices={selectedTour?.prices} roomTypes={selectedTour?.room_types}/>}

                  </Flex>
                </div>
              )
            }
          </Content>
          <Sider width="265px" style={siderStyle} className={`contact-agent-sider ${showContactAgent && 'show-contact-agent-mobile'}`}>
            <div className="toggle-contact-agent" onClick={this.toggleContactAgent}> 
              <span>Contact Agent</span>
            </div>
            <div className="contact-agent">
              <div className="contact-agent_header"> 
                <span>Contact Agent</span>
                <Button className="collapse-contact-agent" color="default" variant="text" 
                  icon={<Icon path={mdiClose} size="19px" />}
                  onClick={this.toggleContactAgent}/>
              </div>
              <div className="contact-agent_content"> 
                <ContactAgentsForm 
                  states={states} 
                  cities={cities} 
                  findAgents={this.findAgents} 
                  filterCities={this.filterCities}
                  filterStates={this.filterStates}/>

                {
                  this.state.showAgentsResults && (
                    <div className="search-results">
                      <Flex vertical gap={20}>
                        {
                          agents.length > 0 && agents.map((agent:Agent) => {
                            return (
                              <Row gutter={2} justify="space-between" className="agent-info">
                                <Col flex="180px"><span className="company" onClick={()=>this.showModal(agent)}>
                                  {agent.name}</span>
                                </Col>
                                <Col flex="none"><Button color="default" variant="filled" shape="circle" size="small" icon={<Icon path={mdiPhoneInTalkOutline} size="16px" />}/></Col>
                                <Col flex="none"><Button color="default" variant="filled" shape="circle" size="small" icon={<Icon path={mdiEmailOutline} size="16px" />}/></Col>
                                <Col>
                                  <div className="contact-numbers">
                                    <Button size="small" color="primary" variant="outlined">
                                      <Icon path={mdiWhatsapp} size="12px" />
                                      {agent.whatsapp}
                                    </Button>
                                  </div>
                                </Col>
                              </Row>
                            )
                          })
                        }
                      </Flex>
                    </div>
                  )
                }
              </div>
            </div>
          </Sider>
        </Layout>
      </Layout>


      <Modal title={<img src={agentData?.image}/>} open={this.state.setIsModalOpen} onCancel={()=>this.closeModal()} footer={null} width={325} centered className="agent-full-contact-details">
        <h2> {agentData?.name} </h2>
        <div className="contact-details">
          <Row gutter={[15, 15]} align="middle">
            <Col span={24}>
              <Icon path={mdiMapMarker} size="15px" />
              <span>{agentData?.address}</span>
            </Col>
          {/* </Row>
          <Row gutter={15} align="middle"> */}
            <Col xs={24} sm={24} lg={6}>
              <Icon path={mdiPhoneInTalkOutline} size="15px" />
              <span>{agentData?.phone}</span>
            </Col>
            <Col xs={24} sm={24} lg={6}>
              <Icon path={mdiWhatsapp} size="15px" />
              <span>{agentData?.whatsapp}</span>
            </Col>
            <Col xs={24} sm={24} lg={9}>
              <Icon path={mdiEmailOutline} size="15px" />
              <span>{agentData?.email}</span>
            </Col>
          </Row>
        </div>
      </Modal>
    </div>
    )
  }

}

export default withParams(ShowPage);